import {
  metricThresholdsExecutionRuns,
  metricThresholdsJobs,
  metricThresholdsPipelines,
  metricThresholdsStages,
  metricThresholdsSuites,
  metricThresholdsTests,
} from '@/shared/utils/metricsThresholds';
import type { MetricThresholdGroup, ProjectMetricThresholds } from '@flowqa/shared';

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

export type ProjectMetricThresholdUpdate = DeepPartial<ProjectMetricThresholds>;

export const defaultProjectMetricThresholds: ProjectMetricThresholds = {
  suites: metricThresholdsSuites,
  executionRuns: metricThresholdsExecutionRuns,
  tests: metricThresholdsTests,
  pipelines: metricThresholdsPipelines,
  stages: metricThresholdsStages,
  jobs: metricThresholdsJobs,
};

export const mergeProjectThresholdGroup = (
  base: MetricThresholdGroup,
  update?: DeepPartial<MetricThresholdGroup>,
): MetricThresholdGroup => ({
  passRate: { ...base.passRate, ...(update?.passRate ?? {}) },
  frequency: { ...base.frequency, ...(update?.frequency ?? {}) },
  avgDuration: { ...base.avgDuration, ...(update?.avgDuration ?? {}) },
  flakeScore: { ...base.flakeScore, ...(update?.flakeScore ?? {}) },
  mttf: { ...base.mttf, ...(update?.mttf ?? {}) },
  greenTime: { ...base.greenTime, ...(update?.greenTime ?? {}) },
});

export const mergeProjectThresholds = (
  source?: ProjectMetricThresholdUpdate,
): ProjectMetricThresholds => ({
  suites: mergeProjectThresholdGroup(defaultProjectMetricThresholds.suites, source?.suites),
  executionRuns: mergeProjectThresholdGroup(
    defaultProjectMetricThresholds.executionRuns,
    source?.executionRuns,
  ),
  tests: mergeProjectThresholdGroup(defaultProjectMetricThresholds.tests, source?.tests),
  pipelines: mergeProjectThresholdGroup(
    defaultProjectMetricThresholds.pipelines,
    source?.pipelines,
  ),
  stages: mergeProjectThresholdGroup(defaultProjectMetricThresholds.stages, source?.stages),
  jobs: mergeProjectThresholdGroup(defaultProjectMetricThresholds.jobs, source?.jobs),
});
